import instance from "../video-api";

export const startSession = async (payload, token) => {
  try {
    let response = await instance({
      url: "/video/startSession",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.log("ERROR:", error);
  }
};
